__turbopack_context__.v({
  "boldText": "RetouchModalContent-module__LNrYxG__boldText",
  "closeButton": "RetouchModalContent-module__LNrYxG__closeButton",
  "container": "RetouchModalContent-module__LNrYxG__container",
  "ctaButton": "RetouchModalContent-module__LNrYxG__ctaButton",
  "description": "RetouchModalContent-module__LNrYxG__description",
  "headline": "RetouchModalContent-module__LNrYxG__headline",
  "imageContainer": "RetouchModalContent-module__LNrYxG__imageContainer",
  "textContainer": "RetouchModalContent-module__LNrYxG__textContainer",
});
